export default String.raw`
{% assign product = product-presentation.Product -%}
{% capture gs1Base -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% assign gs1Currency = customer.Currency -%}
{% assign gs1Name = product.NameNoHtml | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1Description = product.ShortDescription | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1BrandName = product.Brand.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1ManufacturerName = product.Manufacturer.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1ManufacturerUrl = product.Manufacturer.Url | Replace: '[\r\n\t]+', '' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1Gtin = product.UPC | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1ProductID = product.ManufacturerCode | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign gs1ImageUrl = '' -%}
{% if product.Image.Id > 0 and product.Image.Link != null -%}
    {% capture gs1ImageUrl -%}{{gs1Base}}img/{{product.Image.Id}}/{{product.Image.Link}}{% endcapture -%}
{% elseif product.Image.ExternalUrl != null and product.Image.ExternalUrl != '' -%}
    {% assign gs1ImageUrl = product.Image.ExternalUrl -%}
{% endif -%}
{% assign gs1ImageUrl = gs1ImageUrl | Replace: '[\r\n\t]+', '' | StripNewlines | Replace: '"', '\"' -%}
<script type="application/ld+json" id="datablock1">
    {
        "@context": {
            "gs1": "http://gs1.org/voc/",
            "xsd": "http://www.w3.org/2001/XMLSchema#",
            "@vocab": "http://gs1.org/voc/"
        },
        "@type": "gs1:Offer",
        {% unless customer.HidePrices or product.AskForPrice or product.Price == null or product.Price == '' -%}
        "priceSpecification": [
            {
                "priceCurrency": "{{gs1Currency}}",
                "price": {
                    "@value": "{{product.Price | ToString | Replace: config.DecimalSeparator, '.'}}",
                    "@type": "xsd:float"
                },
                {% if product.StockLevel.QuantityControl -%}
                    "eligibleQuantityMaximum": {
                        "value": {
                            "@value": "{{product.StockLevel.Value | ToString | Replace: config.DecimalSeparator, '.'}}",
                            "@type": "xsd:float"
                        },
                        "@type": "gs1:QuantitativeValue"
                    },
                {% endif -%}
                "dutyFeeTaxRate": {
                    "@value": "{{product.VAT | ToString | Replace: config.DecimalSeparator, '.'}}",
                    "@type": "xsd:float"
                },
                "@type": "gs1:PriceSpecification"
            }
        ],
        {% endunless -%}
        "itemOffered": {
            "@type": "gs1:Product"
            {% if gs1Name != '' -%}
            ,"productName": [
                {
                    "@value": "{{gs1Name}}",
                    "@language": "{{page.Language | H}}"
                }
            ]
            {% endif -%}
            {% if gs1Gtin != '' -%}
            ,"gtin": "{{gs1Gtin}}"
            {% endif -%}
            {% if gs1BrandName != '' -%}
            ,"brand": {
                "brandName": [
                    {
                        "@value": "{{gs1BrandName}}",
                        "@language": "{{page.Language | H}}"
                    }
                ],
                "@type": "gs1:Brand"
            }
            {% endif -%}
            {% if gs1Description != '' -%}
            ,"productDescription": [
                {
                    "@value": "{{gs1Description}}",
                    "@language": "{{page.Language | H}}"
                }
            ]
            {% endif -%}
            {% if gs1ImageUrl != '' -%}
            ,"image": {
                "referencedFileURL": {
                    "@id": "{{gs1ImageUrl}}",
                    "@type": "xsd:anyURI"
                },
                "@type": "gs1:ReferencedFileDetails"
            }
            {% endif -%}
            {% if gs1ManufacturerName != '' -%}
            ,"manufacturer": {
                {% if gs1ManufacturerUrl != null and gs1ManufacturerUrl != '' -%}
                "@id": "{{gs1Base}}{{gs1ManufacturerUrl}}",
                {% endif -%}
                "organizationName": [
                    {
                        "@value": "{{gs1ManufacturerName}}",
                        "@language": "{{page.Language | H}}"
                    }
                ],
                "@type": "gs1:Organization"
            }
            {% endif -%}
            {% if gs1ProductID != '' -%}
            ,"productID": "{{gs1ProductID}}"
            {% endif -%}
            {% if product.Weight > 0 -%}
            ,"grossWeight": {
                "value": {
                    "@value": "{{product.Weight | ToString | Replace: config.DecimalSeparator, '.'}}",
                    "@type": "xsd:float"
                },
                "unitCode": "KGM",
                "@type": "gs1:QuantitativeValue"
            }
            {% endif -%}
            {% assign substitutesSize = product.RelatedProducts.Substitutes | Size -%}
            {% if substitutesSize > 0 -%}
            ,"equivalentProduct": [
                {% for substitute in product.RelatedProducts.Substitutes -%}
                    {
                        "@id": "{{gs1Base}}{{substitute.Url}}",
                        "@type": "gs1:Product"
                    }
                    {% if forloop.index != substitutesSize -%}
                        ,
                    {% endif -%}
                {% endfor -%}
            ]
            {% endif -%}
        }
    }
</script>
`